import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { useStore } from '@/store'
import NewsDetails from '@/components/NewsDetails'
import ImagePreview from '@/components/ImagePreview'
import NewsListItem from '@/components/NewsListItem'

import styles from './style.module.less'

export default defineComponent({
  props: {
    dataSource: {
      type: Array as PropType<(NewsItem & { bgColor?: string; })[]>,
      default: () => []
    },
    firstBig: Boolean as PropType<boolean>,
    showNumber: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    allowRecommond: Boolean as PropType<boolean>,
  },
  setup(props) {
    const stroe = useStore()

    return () => {
      return (
        <div class={[ styles.recommondBlock, props.showNumber ? '' : styles.showNoCount ]}>
          {
            props.dataSource.map((item, index) => {
              return (
                <div
                  class={[ styles.recommondItem, props.firstBig && index === 0 ? styles.big : null ]}
                  onClick={() => stroe.global.publicOpenDetails(item, true)}
                >
                  {
                    props.showNumber && (
                      <div
                        style={{ background: item.bgColor, marginBottom: props.firstBig && index === 0 ? 0 : undefined }}
                        class={styles.recommondCurrent}
                      >
                        {`0${index + 1}`}
                      </div>
                    )
                  }
                  {
                    props.firstBig && index === 0 ? (
                      <>
                        <ImagePreview
                          width={404}
                          height={300}
                          url={item.imageShow || ''}
                          alt={item.newsTitle}
                          coverStyle={item.coverStyle as any}
                          record={item}
                        />
                        <div class={[ styles.title, 'mb-14px mt-12px' ]}>{item.newsTitle}</div>
                        <NewsDetails
                          time={item.publishTime}
                          channelName={item.mainChannel?.channelName || ''}
                        />
                      </>
                    ) : (
                      <NewsListItem
                        stopClick
                        recommond={props.allowRecommond ? true : !!item.traceId}
                        imageWidth={132}
                        imageHeight={100}
                        listItem={item}
                        showBottomBorder={false}
                        showPaddingBottom={false}
                      />
                    )
                  }
                </div>
              )
            })
          }
        </div>
      )
    }
  }
})
